import { FirestoreTimestampObject } from "../models/firestore-timestamp-object";

export function convertFirestoreTimestampToDate(timestamp: Date | FirestoreTimestampObject | { toDate: () => Date } | string | number | null | undefined): Date | null {
    if(timestamp === null || typeof timestamp === 'undefined') {
        return null;
    }

    if(timestamp instanceof Date) {
        return timestamp;
    }

    if(typeof timestamp === 'object' && timestamp !== null && 'toDate' in timestamp && typeof (timestamp as any).toDate === 'function') {
        return (timestamp as { toDate: () => Date }).toDate();
    }

    if(typeof timestamp === 'object' && timestamp !== null && '_seconds' in timestamp && typeof (timestamp as any)._seconds === 'number' && '_nanoseconds' in timestamp && typeof (timestamp as any)._nanoseconds === 'number') {
        const tsObject = timestamp as FirestoreTimestampObject;

        return new Date(tsObject._seconds * 1000 + Math.floor(tsObject._nanoseconds / 1_000_000));
    }

    if(typeof timestamp === 'string' || typeof timestamp === 'number') {
        try {
            const date = new Date(timestamp);

            return isNaN(date.getTime()) ? null : date;
        } catch(e) {
            return null;
        }
    }

    return null;
}
